import styled from 'styled-components';

export const SupportTabs = styled.nav`
  display: flex;
  flex-wrap: nowrap;
  gap: 1.75rem;
  margin: 0 0 1.25rem;
  border-bottom: 1px solid ${({ theme }) => theme.grey};
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }
`;

export const SupportTab = styled.button<{ $active: boolean }>`
  flex-shrink: 0;
  position: relative;
  padding: 0.75rem 0;
  border: none;
  background: transparent;
  color: ${({ theme, $active }) => ($active ? theme.dark : theme.midGrey)};
  font-size: 1rem;
  font-weight: ${({ $active }) => ($active ? 700 : 500)};
  font-family: inherit;
  cursor: pointer;
  white-space: nowrap;

  &::after {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    bottom: -1px;
    height: 2px;
    border-radius: 2px 2px 0 0;
    background: ${({ theme, $active }) => ($active ? theme.dark : 'transparent')};
  }

  &:hover {
    color: ${({ theme }) => theme.dark};
  }
`;

export const StatusText = styled.span<{ $tone?: 'positive' | 'negative' | 'muted' | 'warning' }>`
  font-size: 0.875rem;
  font-weight: 600;
  color: ${({ theme, $tone }) => {
    if ($tone === 'positive') return theme.positive;
    if ($tone === 'negative') return theme.negative;
    if ($tone === 'warning') return theme.middle;
    return theme.midGrey;
  }};
`;

export const DescriptionBlock = styled.p`
  margin: 0;
  white-space: pre-line;
  overflow-wrap: anywhere;
  font-size: 0.875rem;
  line-height: 1.6;
  color: ${({ theme }) => theme.dark};
`;

export const AttachmentGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
`;

export const AttachmentThumb = styled.a`
  display: block;
  width: 6rem;
  height: 6rem;
  border-radius: 0.5rem;
  border: 1px solid ${({ theme }) => theme.grey};
  overflow: hidden;
  background: ${({ theme }) => theme.lightGrey};

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }

  &:hover {
    border-color: ${({ theme }) => theme.primary};
  }
`;

export const StatusRow = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 0.75rem;
  flex-wrap: wrap;
`;
